import { ApplicationDataStore } from '../application/ApplicationDataStore';
import { ResidenceOwnership2 } from '@servicetitan/financing-api-client';
import { formatCurrency, DataItem } from '@servicetitan/financing-utils-shared';
import startCase from 'lodash/startCase';
import { ReviewCard } from './ReviewCard';
import { useRef } from 'react';
import { ImperativeForm } from '../common/Form';
import { ServicePropertyContainer } from '../service-property';

export const ServiceProperty = () => {
    const { applicationData } = ApplicationDataStore.useStore();
    const serviceProperty = applicationData.serviceProperty;
    const mortgageAmount =
        applicationData.serviceProperty?.primaryApplicant?.housingType === ResidenceOwnership2.Own
            ? applicationData.serviceProperty?.primaryApplicant?.monthlyHousingPayment
            : 0;
    const formRef = useRef<ImperativeForm>(null);

    return (
        <ReviewCard title="Service Property" formRef={formRef}>
            <ReviewCard.View>
                <DataItem
                    label="Own Or Rent"
                    text={startCase(serviceProperty?.primaryApplicant?.housingType)}
                />
                <DataItem
                    label="Monthly Mortgage Amount"
                    text={formatCurrency(mortgageAmount ?? 0)}
                />
                <DataItem
                    label="Property Type"
                    text={startCase(serviceProperty?.primaryApplicant?.propertyType)}
                />
                <DataItem label="Improvement Type" text={serviceProperty?.improvement} />
            </ReviewCard.View>
            <ReviewCard.Edit>
                <ServicePropertyContainer formRef={formRef} />
            </ReviewCard.Edit>
        </ReviewCard>
    );
};
